import { render, staticRenderFns } from "./classifyList.vue?vue&type=template&id=731330fa"
import script from "./classifyList.vue?vue&type=script&lang=js"
export * from "./classifyList.vue?vue&type=script&lang=js"
import style0 from "./classifyList.vue?vue&type=style&index=0&id=731330fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports